import React from 'react'
import { useTranslation } from 'react-i18next'
/* COMPONENTS */
import BPButton from '../BPButton'

const ToolbarRefreshButton = ({ onClick, ...rest}) => {
  const { t } = useTranslation()
  return (
    <BPButton type='button' label={t('refresh')} tooltip={t('refresh')} icon='refresh' className='bp3-intent-refresh' onClick={onClick} {...rest}/>
  )
}

export default ToolbarRefreshButton
